import React, { Component } from 'react';
import * as actionCreators from '../store/actions';
import FaEdit from 'react-icons/lib/fa/edit';
import { connect } from 'react-redux';
import { Switch, Route, Link } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import { merge } from 'ramda';
import moment from 'moment';

const required = value => (value ? undefined : "Required");
const isDate = value => (/\d{4}-\d{2}-\d{2}/.test(value) ? undefined : "Must be in the form yyyy-mm-dd");
const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

class PatientAddForm extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <div className="form-group">
          <Field className="form-control" name="name" validate={required}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} type="text" placeholder="Name" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}
          </Field>
          <Field className="form-control" name="dob" validate={composeValidators(required, isDate)}>
            {({ input, meta }) => (
               <div>
                 <input className="form-control" {...input} type="text" placeholder="Date of Birth (yyyy-mm-dd)" />
                 {meta.error && meta.touched && <span>{meta.error}</span>}
               </div>
             )}
          </Field>
	  {this.props.showCancel ? 
	    <button type="button" disabled={this.props.submitting} onClick={this.props.onCancel} className="btn">
	      Cancel
	    </button>
	    : "" }
          <button type="submit" disabled={this.props.submitting || this.props.pristine}
            className="btn btn-primary">
            {this.props.label || "Add New Patient"}
          </button>          
        </div>
      </form>
    );
  }
}

const BcpAddForm = ({handleSubmit, pristine, invalid, submitting}) => (
  <form onSubmit={handleSubmit}>
    <div className="form-group">
      <Field className="form-control" name="datePickedUp" validate={required}>
        {({ input, meta }) => (
           <div>
             <input className="form-control" {...input} type="text" placeholder="Date" />
             {meta.error && meta.touched && <span>{meta.error}</span>}
           </div>
         )}
      </Field>
      <Field className="form-control" name="ocType" validate={required}>
        {({ input, meta }) => (
           <div>
             <input className="form-control" {...input} type="text" placeholder="Type" />
             {meta.error && meta.touched && <span>{meta.error}</span>}
           </div>
         )}
      </Field>
      <Field className="form-control" name="numberSold" validate={required}>
        {({ input, meta }) => (
           <div>
             <input className="form-control" {...input} type="text" placeholder="Number Sold" />
             {meta.error && meta.touched && <span>{meta.error}</span>}
           </div>
         )}
      </Field>
      <Field className="form-control" name="numberLeft" validate={required}>
        {({ input, meta }) => (
           <div>
             <input className="form-control" {...input} type="text" placeholder="Number Left" />
             {meta.error && meta.touched && <span>{meta.error}</span>}
           </div>
         )}
      </Field>
      <Field className="form-control" name="lotNumbers" validate={required}>
        {({ input, meta }) => (
           <div>
             <input className="form-control" {...input} type="text" placeholder="Lot Numbers" />
             {meta.error && meta.touched && <span>{meta.error}</span>}
           </div>
         )}
      </Field>
      <button type="submit" disabled={submitting || pristine} className="btn btn-primary">Add</button>
    </div>
  </form>
);

class PatientSearch extends Component {
  constructor() {
    super();
    this.executeSearch = this.executeSearch.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.addNew = this.addNew.bind(this);
    
    this.state = {term: '', timeoutID: null};
  }
  executeSearch() {
    this.props.searchPatient(this.state.term);
    this.setState({term: this.state.term, timeoutID: null});
  }
  handleSearch(event) {
    var query = event.target.value.toLowerCase();
    console.log("updated query", query);
    if (this.state.timeoutID) {
      window.clearTimeout(this.state.timeoutID);
    }
    var timeoutID = null;
    if (query !== "") {
      timeoutID = window.setTimeout(this.executeSearch, 300);
    }
    this.setState({ term: query, timeoutID });
  }
  addNew(patient) {
    console.log("want to add new patient", patient);
    this.props.addPatient(patient).then( ({meta, payload, type}) => {
      console.log("got payload", payload);
      if (payload.success) {
        this.props.history.push(`/patients/${payload.patient.id}`);
      }
    });
  }
  render() {
    return (
      <div className="patient-search row">
        <div className="col-6">
          <h2>Search</h2>
          <input type="text" className="form-control" placeholder="Search term" onChange={this.handleSearch} />
          <ul>
            {this.props.results.map( (result) =>
              <li key={result.id}><Link to={`/patients/${result.id}`}>{result.name} - {result.dob}</Link></li>)}
          </ul>
        </div>
        <div className="col-6">
          <h2>Add</h2>
          <Form onSubmit={this.addNew} component={PatientAddForm} />
        </div>
      </div>
    );
  }
}

const selector = (state) => ({results: state.bcp.search_results});
const PatientSearchComponent = connect(selector, actionCreators)(PatientSearch);

const PatientRow = ({ id, datePickedUp, ocType, numberSold, numberLeft, lotNumbers }) => (
  <tr key={id}>
    <td>{datePickedUp}</td>
    <td>{ocType}</td>
    <td>{numberSold}</td>
    <td>{numberLeft}</td>
    <td>{lotNumbers}</td>
  </tr>
)

class PatientForm extends Component {
  constructor() {
    super();
    this.fetchPatient = this.fetchPatient.bind(this);
    this.openNew = this.openNew.bind(this);
    this.closeNew = this.closeNew.bind(this);
    this.addNew = this.addNew.bind(this);
    this.patientEdit = this.patientEdit.bind(this);
    this.savePatient = this.savePatient.bind(this);
    this.state = {addNew: false, editPatient: false};
  }
  componentWillMount() {
    this.fetchPatient();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchPatient();
    }
  }
  patientEdit(editMode) {
    this.setState(merge(this.state, {editPatient: editMode}));
  }
  fetchPatient() {
    console.log("should fetch patient", this.props.match.params.id);
    this.props.fetchPatient(this.props.match.params.id);
  }
  openNew() {
    this.setState(merge(this.state, {addNew: true}));
  }
  closeNew() {
    this.setState(merge(this.state, {addNew: false}));
  }
  addNew(prescription) {
    console.log("add prescription", prescription);
    this.props.addPrescription(this.props.patient, prescription)
        .then(this.fetchPatient)
        .then(this.closeNew);
  }
  savePatient(patient) {
    console.log("updating", patient);
    this.props.updatePatient(patient)
	.then(() => this.patientEdit(false));
  }
  render() {
    const {patient} = this.props;
    const {editPatient} = this.state;
    const today = moment().format("YYYY-MM-DD");
    if (!patient) {
      return (<div>Loading...</div>);
    }
    if (patient) {
      return (
        <div className="card">
          <div className="card-header">Patient: {patient.name} {patient.dob}
	    {editPatient ?
	     <div>
	       <Form onSubmit={this.savePatient} initialValues={patient} showCancel={true} label="Update" component={PatientAddForm} onCancel={() => this.patientEdit(false)}/>
	     </div>
	     : <FaEdit onClick={() => this.patientEdit(true)}/>}
	  </div>
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Type</th>
                <th scope="col">Num. Sold</th>
                <th scope="col">Num. Left</th>
                <th scope="col">Lot Numbers</th>
              </tr>
              <tr>
                <th colSpan="5">
                  {this.state.addNew ?
                   <Form onSubmit={this.addNew} initialValues={{datePickedUp: today}} component={BcpAddForm} /> :
                   <div onClick={this.openNew}>Add New</div>
                  }
                </th>
              </tr>
            </thead>
            <tbody>
              {patient.prescription_pickups.map(PatientRow)}
            </tbody>
          </table>
        </div>);
    }
    console.log("patient props", this.props);
  }
}
const patientFormSelector = (state, ownProps) => ({patient: state.bcp.patients[ownProps.match.params.id]});
const PatientFormComponent = connect(patientFormSelector, actionCreators)(PatientForm);

class Patients extends Component {
  render() {
    return (
      <Switch>
        <Route path='/patients' exact component={PatientSearchComponent} />
        <Route path='/patients/:id' component={PatientFormComponent} />
      </Switch>
    );
  }
}

export default Patients;



// WEBPACK FOOTER //
// ./src/components/bcp.js